import {Controller, useFormContext} from "react-hook-form";
import {Select, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";

export function KycGenderFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();

  return (
    <FormField
      id="gender"
      label="Gender"
      renderInput={(id) => (
        <Controller
          control={control}
          name="gender"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Select
                id={id}
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value}
                placeholder="Select your gender"
                ref={ref}
                style={{width: "100%"}}
                options={[
                  {
                    value: "Male",
                    label: "Male",
                  },
                  {
                    value: "Female",
                    label: "Female",
                  },
                  {
                    value: "Other",
                    label: "Other",
                  },
                ]}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
